// src/pages/Privacy.tsx
import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen p-8 bg-secondary text-offwhite max-w-3xl mx-auto space-y-6">
      <Link to="/runtime" className="block mb-4 text-teal hover:underline">
        ← Back to Runtime
      </Link>
      <h1 className="text-3xl font-semibold">Privacy Policy</h1>

      <p>Last updated: June 8, 2025</p>

      <section>
        <h2 className="text-2xl font-semibold mb-2">
          1. Information We Collect
        </h2>
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Account Data:</strong> Email, display name.
          </li>
          <li>
            <strong>Usage Data:</strong> Number of messages, sessions, tasks.
          </li>
          <li>
            <strong>Payment Data:</strong> Transaction metadata via Paystack.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">2. How We Use Your Data</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>Authentication and account management.</li>
          <li>Billing and subscription enforcement.</li>
          <li>Improving and troubleshooting the Service.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">3. Data Sharing</h2>
        <p>
          We use Firebase (Google) and Paystack to process data. We do not sell
          your personal data.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">4. Data Retention</h2>
        <p>
          We retain your data as long as your account exists. You can request
          deletion by contacting us.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">5. Your Rights</h2>
        <p>
          You may access, correct, or delete your data by emailing us at the
          contact page. {/* <code>support@yourdomain.com</code>. */}
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">6. Contact</h2>
        <p>
          Questions?{" "}
          <Link to="/contact" className="text-teal hover:underline">
            Contact us
          </Link>
          .
        </p>
      </section>
    </div>
  );
}
